import * as React from 'react'

export const useEnterKeyHandler = () => {
  return React.useCallback(
    (e: React.KeyboardEvent, func: (event: React.KeyboardEvent) => void) => {
      if (e.key === 'Enter') {
        func(e)
      }
    },
    []
  )
}
